'use client';

import React, { useState } from 'react';
import classes from './shop-detail-home.module.scss';
import { Languages } from '@/lib/dictionaries';

const information: { [key: string]: any } = {
  ko: [
    {
      title: '반품/교환 정보',
      contents: [
        {
          subject: '반품/교환 방법 ',
          body: '우측 하단에 Customer Service 채널로 접수 바랍니다. ',
        },
        {
          subject: '반품/교환 가능 기간',
          body:
            '구매자는 상품을 수령한 날부터 7일 이내에 교환/반품 신청을 하여야 하며, \n' +
            '\n' +
            '표시·광고 내용과 다르거나 계약 내용과 다르게 이행된 경우에는 상품 수령 후 3개월 이내에 청약 철회가 가능합니다. \n' +
            '\n' +
            '(단, 변심의 경우 교환은 불가하며, 반품 취소만 가능합니다.) ',
        },
        {
          subject: '반품/교환 비용 ',
          body:
            '구매자의 변심으로 반품을 원할 경우에는 구매자가 왕복 배송비 지불 \n' +
            '\n' +
            '상품 하자나 제품 불일치, 배송 이슈로 인한 반품의 경우에는 판매자가 배송비 지불 ',
        },
        {
          subject: '반품/교환시 유의사항 ',
          body:
            '아래와 같은 경우 반품/교환이 제한될 수 있습니다. \n' +
            '\n' +
            '구매자에게 책임이 있는 사유로 상품이 멸실 또는 훼손된 경우(단, 내용 확인을 위한 포장 개봉의 경우는 예외) \n' +
            '\n' +
            '구매자의 전부 또는 일부의 사용, 소비(디지털코드 등록 포함)에 의해 상품의가치가 현저히 감소한 경우 \n' +
            '\n' +
            '시간의 경과에 의하여 재판매가 곤란할 정도로 상품의 가치가 현저히 감소한경우 \n' +
            '\n' +
            '복제가 가능한 상품의 포장을 훼손한 경우(앨범/도서/영상출판물/포토카드/포스터카드/포스터 등을 비롯한 복제 가능한 상품의 포장 개봉 시) \n' +
            '\n' +
            '주문/제작 상품의 제작이 이미 진행된 경우(판매자에게 회복불가능한 손해가예상되고, 그러한 예정으로 청약철회권 행사가 불가하다는 사실을 서면 동의받은 경우) \n' +
            '\n' +
            '상품의 일부 구성품을 사용하였거나, 분실하였거나 취급 부주의로 인한 파손/고장/오염으로 재판매 불가한 경우, 일부 구성품이 동봉되지 않은 채 반송된 경우 \n' +
            '\n' +
            '- \n' +
            '\n' +
            '아웃박스는 상품 보호를 위한 충격 방지용으로 제작되어 스크래치 및 구겨짐, 변색 등이 포장/배송 과정에서 생겨날 수 있고 이는 교환/반품/환불 사유가 될 수 없습니다 \n' +
            '\n' +
            '특전으로 제공되는 포토카드 재질의 특성상 5mm 이하의 찍힘, 스크래치, 작은 점, 눌림 자국 등 부분은 인쇄 공정 상 생길 수 있는 부분으로 교환/반품/환불 사유가 될 수 없습니다.\n' +
            '\n' +
            '각 상품별로 아래와 같은 사유로 반품/교환이 제한될 수 있습니다. \n' +
            '-\n' +
            '[의류/가방/신발/ 패션잡화] \n' +
            '\n' +
            '세탁, 상품 얼룩, 향수 냄새, 탈취제 냄새, 사용 흔적 등으로 상품의 가치가 현저히 감소한 경우 \n' +
            '-\n' +
            '[앨범/도서/영상출판] \n' +
            '\n' +
            '복제 가능한 상품의 포장이 개봉된 경우 \n' +
            '\n' +
            '일부 구성품을 사용하였거나, 분실하였거나 취급 부주의로 인한 파손/고장/오염으로 재판매 불가한 경우 \n' +
            '\n' +
            '일부 구성품이 동봉되지 않은 채 반송된 경우 \n' +
            '\n' +
            '교환은 불량일 경우에만 동일한 상품 및 동일한 옵션에 한하여 가능합니다. 이 외에 경우에는 반품 후 재구매절차를 진행하셔야 합니다. \n' +
            '\n' +
            '교환신청을 하더라도 판매자에게 교환할 물품의 재고가 없는 경우에는 교환이 불가능하며, 이 경우에 해당 상품의 주문을 취소처리 후, 결제시 선택했던 결제 수단으로 환불처리 됩니다. \n' +
            '\n' +
            '대금 환불 및 환불 지연에 따른 배상금 지급 조건, 절차 등은 전자상거래 등에서 의 소비자 보호에 관한 법률에 따라 처리함. \n' +
            '\n' +
            '( 단, 공동구매 상품의 경우 서포트가 함께 진행되므로 교환 및 환불이 불가합니다. )',
        },
        {
          subject: '소비자 피해 보상 및 환불지연에 따른 배상',
          body: '상품의 불량에 의한 반품, 교환, A/S, 환불, 품질보증 및 피해보상 등에 관한 사항은 소비자분쟁해결기준(공정거래위원회 고시)에 준하여 처리됨. ',
        },
        {
          subject: '기타',
          body: '일부 규정은 국내구매자 분들께만 해당되며, 해외구매자 분들을 위한 상세 안내는 우측 하단에 Customer Service 채널로 문의 바랍니다. ',
        },
      ],
    },
  ],
  ja: [
    {
      title: '[ 返品/交換について ] ',
      contents: [
        {
          subject: '返品・交換方法  ',
          body: '右下のカスタマーサービスチャネルからお問い合わせください ',
        },
        {
          subject: '返品・交換受付可能期間 ',
          body:
            '交換・返品の受付は、商品到着後7日以内とさせていただきます。 \n' +
            '\n' +
            '表示・広告の内容と異なる場合や、契約内容と異なる場合は、商品の到着から3ヶ月以内に契約を撤回することができます。 \n' +
            '\n' +
            '(ただし、お客様ご都合による交換は受け付けておりません。返品のみ可能です。) ',
        },
        {
          subject: '返品・交換時の送料 ',
          body:
            '購入者のご都合による返品の場合、往復の送料は購入者様のご負担となります。 \n' +
            '\n' +
            '商品の不具合や誤配送などによる返品の場合、送料は販売者負担となります。 ',
        },
        {
          subject: '返品・交換のご注意 ',
          body:
            '以下の場合には、返品・交換が制限される場合があります。 \n' +
            '\n' +
            'お客様に責任がある理由により、商品が消失もしくは破損した場合（ただし、商品の内容確認のために、包装を開封した場合は除く） \n' +
            '\n' +
            'お客様の全部または一部の使用、消費（デジタルコードの登録を含む）によって、商品の価値が著しく低下した場合 \n' +
            '\n' +
            '時間の経過により、再販売ができなくなるほど商品の価値が著しく低下した場合 \n' +
            '\n' +
            '複製が可能な商品の包装を破損させた場合（アルバム/書籍/映像出版物/フォトカード/ポストカード/ポスターなどを含む複製可能な商品の開封時） \n' +
            '\n' +
            '注文・制作商品の制作がすでに行われている場合（販売者に回復不可能な損害が予想され、そのような予定で購入の取消権の行使ができないという事実を書面で同意を受けた場合） \n' +
            '\n' +
            '商品の一部構成品を使用、または紛失、取り扱いの不注意による破損・故障・汚染で再販売できない場合、一 \n' +
            '\n' +
            '部の構成品が同梱されていない状態で返送された場合" \n' +
            '\n' +
            '- \n' +
            '\n' +
            'アウターボックスは商品の保護のために衝撃防止用として製作されており、包装や配送の過程で傷、折れ、変色が発生する場合がありますが、これらは交換、返品、返金の対象にはなりません。 \n' +
            '\n' +
            '特典として提供されるフォトカードは材質の特性上、5mm以下のへこみ、傷、小さな点、押され跡などが印刷工程上で発生することがありますが、これらは交換、返品、返金の対象にはなりません。\n' +
            ' \n' +
            '各商品別に、以下のような理由で返品・交換が制限される場合があります。 \n' +
            '\n' +
            '衣類・カバン・靴・ファッション雑貨 \n' +
            '\n' +
            '洗濯、商品の汚れ、香水の香り、消臭剤の匂い、使用の形跡などで商品の価値が著しく低下した場合 \n' +
            '\n' +
            '- \n' +
            '\n' +
            'アルバム・書籍・映像出版物 \n' +
            '\n' +
            '複製できる商品の包装が開封された場合 \n' +
            '\n' +
            '一部構成品を使用、または紛失、取り扱いの不注意による破損・故障・汚染で再販売できない場合 \n' +
            '\n' +
            '一部の構成品が同梱されていない状態で返送された場合 \n' +
            '\n' +
            '交換は不良品の場合に限り、同一の商品及びオプションで対応いたします。それ以外の場合は、返品後、再注文してください。 \n' +
            '\n' +
            '交換申込後、販売者に交換する商品の在庫がない場合、交換はいたしかねます。その際は、当該商品のご注文はキャンセルされ、ご注文時にお支払いいただいた方法で返金いたします。 ' +
            '\n' +
            '(ただし、共同購入商品の場合、サポートが一緒に行われるため、交換及び返品は致しかねます。)',
        },
        {
          subject: '消費者被害補償及び払い戻しの遅延による賠償 ',
          body:
            'お届けした商品に不具合があった場合の返品、交換、アフターサービス、払い戻し、そして品質保証及び被害補償等に関する事項は、消費者紛争解決基準（韓国の公正取引委員会告示）に準じて行われます。 \n' +
            '\n' +
            '代金の払い戻し、及び払い戻しの遅延による賠償金の支払い条件や手続き等は、韓国の電子商取引等における消費者保護に関する法律に基づいて処理いたします。 ',
        },
        {
          subject: 'その他 ',
          body: '一部の規定は国内のお客様のみ該当します。海外のお客様向けの詳細な案内については、右下のカスタマーサービスチャネルよりお問い合わせください ',
        },
      ],
    },
  ],
  en: [
    {
      title: 'About Return and Exchange',
      contents: [
        {
          subject: 'Returns & Exchanges',
          body: 'Please submit your inquiry through the Customer Service channel located at the bottom right',
        },
        {
          subject: 'Return & Exchange Period ',
          body:
            'The customer must request a return/exchange within seven days from the date of receiving the product. \n' +
            '\n' +
            'In cases where the product does not match the indicated/advertised content or is not performed according to the contract, withdrawal of the offer is possible within three months after receiving the product. \n' +
            '\n' +
            '(However, in the case of a change of mind, only returns are possible. Exchanges will not be allowed.) ',
        },
        {
          subject: 'Return & Exchange Fees',
          body:
            'If the customer wishes to return the product due to a change of mind, the customer bears the round-trip shipping fee. \n' +
            '\n' +
            'In the case of defective products, product mismatches, or returns due to delivery issues, the seller covers the shipping costs. ',
        },
        {
          subject: 'Notes for Refunds & Exchanges',
          body:
            'Refunds & exchanges may be restricted in the following cases. \n' +
            '\n' +
            'Where the product is destroyed or damaged due to a cause attributable to the customer (except in cases where the package is opened for checking the content); \n' +
            '\n' +
            "Where the product's value has substantially decreased due to the customer's total or partial use or consumption (including the redeeming of digital codes); \n" +
            '\n' +
            'Where the value of the product has substantially decreased due to the elapse of time, making resale difficult or impossible; \n' +
            '\n' +
            'Where the package of copyable products has been destroyed (where the packaging of copyable products including albums, books, video publications, photocards, postcards, and posters is opened); \n' +
            '\n' +
            'Where making of the made-to-order product has already proceeded (where irreparable damage to the seller is foreseen, and the seller has obtained written consent acknowledging that the right of withdrawal cannot be exercised due to such foreseen damage); \n' +
            '\n' +
            'Where some components of the product have been used, lost, or are not resalable due to damage/failure/contamination caused by mishandling, or the product is returned with some components missing; \n' +
            '\n' +
            '- \n' +
            '\n' +
            'The outer box is designed with shock protection to safeguard the product, and scratches, creases, or discoloration may occur during packaging and shipping. These do not qualify as reasons for exchange, return, or refund. \n' +
            '\n' +
            'Due to the nature of the photocard material, minor imperfections such as dents, scratches, small spots, or pressure marks within 5mm may occur during the printing process. These are not considered valid reasons for exchange, return, or refund.\n' +
            '\n' +
            'Refunds & exchanges in each product category may be restricted for the following cases: \n' +
            '\n' +
            '- \n' +
            '\n' +
            'Clothing, bags, shoes, fashion accessories \n' +
            '\n' +
            "Where the product's value has substantially decreased due to washing, stains on the product, odor from fragrance or deodorant, signs of use, etc. \n" +
            '\n' +
            '- \n' +
            '\n' +
            'Albums, books, video publications \n' +
            '\n' +
            "Where the copyable product's packaging has been opened; \n" +
            '\n' +
            'Where some components of the product have been used, lost, or are not resalable due to damage/failure/contamination caused by mishandling; \n' +
            '\n' +
            'Where the product is returned with some components missing; \n' +
            '\n' +
            '- \n' +
            '\n' +
            'Exchange is only possible for the same product and the same options in the case of defective products. In other cases, you must return the defective product and make a new purchase. \n' +
            '\n' +
            'Even if an exchange request is made, if the seller does not have the stock for the item to be exchanged, the exchange is not possible. In this case, the order for the relevant product will be canceled, and a refund will be processed to the payment method used for the purchase. ' +
            '\n' +
            '(Note: As group purchasing items are linked with artist support, exchanges and refunds are not available.)',
        },
        {
          subject: 'Compensation for Consumer Damages and Refund Delays: ',
          body:
            'Matters related to returns, exchanges, after-sales service, refunds, quality guarantees, and compensation for damages due to defective products are handled in accordance with the Consumer Dispute Resolution Criteria set by the Korea Fair Trade Commission. \n' +
            '\n' +
            'Conditions and procedures for refund and compensation for delay are processed in accordance with the Act on the Consumer Protection in Electronic Commerce of South Korea. ',
        },
        {
          subject: 'For international customers ',
          body: 'Some regulations apply only to domestic customers. For detailed information for international customers, please inquire through the Customer Service channel located at the bottom right. ',
        },
      ],
    },
  ],
  zh: [
    {
      title: '退货/换货指南 ',
      contents: [
        {
          subject: '退货/换货方式',
          body: '请通过右下角的Customer Service渠道提交申请。',
        },
        {
          subject: '退货/换货期限',
          body:
            '买家需在收到商品后7日内申请退货/换货， \n' +
            '若商品与标示或广告内容不符，或未按合同履行的情况，可在收货后3个月内撤销订单。 \n' +
            '（但若为个人原因退货，仅可申请退货取消，换货不适用。） ',
        },
        {
          subject: '退货/换货费用',
          body:
            '若因买家个人原因申请退货，买家需支付往返运费； \n' +
            '若因商品瑕疵、产品不符或配送问题申请退货，运费由卖家承担。 ',
        },
        {
          subject: '退货/换货注意事项',
          body:
            '在以下情况下，退货/换货可能受到限制： \n' +
            '\n' +
            '因买家责任导致商品灭失或损坏的情况（用于内容确认的包装打开除外） \n' +
            '因买家全部或部分使用、消费（包括数字代码注册）导致商品价值显著减少的情况 \n' +
            '随着时间推移，商品价值显著下降，难以再次销售的情况 \n' +
            '可复制商品的包装已损坏（例如专辑/书籍/影音出版物/专辑小卡等可复制商品开封的情况） \n' +
            '订单/定制商品的制作已开始（卖家已预见无法恢复的损失并获得书面同意撤销订单不可行的情况） \n' +
            '商品的部分配件已使用或遗失，或因不当处理导致的损坏/故障/污染无法再次销售，或部分配件未随商品退回的情况 \n' +
            '（但是，若团购产品是绑定应援活动的情况下，无法换货和退款。）',
        },
        {
          subject: '包装盒',
          body: '包装盒设计用于保护商品，可能在包装/运输过程中出现划痕、折痕、变色等情况，不能作为退货/换货/退款的理由。',
        },
        {
          subject: '照片卡',
          body: '作为特典提供的照片卡，由于材料特性，5mm以下的凹痕、划痕、小点、压痕等可能会在印刷过程中产生，不能作为退货/换货/退款的理由。',
        },
      ],
    },
    {
      title: '各商品的退货/换货限制条件 ',
      contents: [
        {
          subject: '[服装/包包/鞋子/时尚配饰]',
          body: '因清洗、商品污渍、香水味、除臭剂味、使用痕迹等导致商品价值显著减少的情况 ',
        },
        {
          subject: '[专辑/书籍/影音出版物]',
          body:
            '可复制商品包装已开封 \n' +
            '商品的部分配件已使用、遗失或因不当处理导致损坏/故障/污染无法再次销售 \n' +
            '部分配件未随商品退回的情况 \n' +
            '仅在商品有瑕疵时可更换为相同商品及相同选项。若为其他情况，需退货后重新购买。 \n' +
            '即使申请换货，若卖家无库存可供更换，将无法换货。在此情况下，将取消该商品订单，并按原付款方式退款。',
        },
        {
          subject: '消费者损害赔偿及退款延迟的赔偿',
          body:
            '商品因瑕疵导致的退货、换货、售后、退款、质量保证及损害赔偿等事项按照《消费者争议解决标准》（公平交易委员会公告）进行处理。 \n' +
            '退款及因退款延迟的赔偿金支付条件、流程等依据《电子商务等消费者保护法》进行处理。 ',
        },
        {
          subject: '其他',
          body: '部分规定仅适用于国内买家，关于海外买家的详细信息，请通过右下角的Customer Service渠道咨询。 ',
        },
      ],
    },
  ],
};

function ShopDetailRefund({ lang }: { lang: Languages }) {
  lang = lang === 'id' ? 'en' : lang;
  const [opens, setOpens] = useState<boolean[]>([true]);

  const handleToggleOpen = (index: number) => {
    setOpens(prev => {
      const updated = [...prev];
      updated[index] = !updated[index];
      return updated;
    });
  };

  function drawTitle(title: string, index: number) {
    return (
      <a
        className={classes.itemHeadBox}
        onClick={() => handleToggleOpen(index)}
      >
        {title}
      </a>
    );
  }

  return (
    <div className={classes.detailEtcGroup}>
      <div className={classes.etcList}>
        {information[lang].map(
          (
            item: {
              title: string;
              contents: { subject: string; body: string }[];
            },
            index: number,
          ) => (
            <div className={classes.etcItem} key={`exchange-refund-${index}`}>
              {drawTitle(item.title, index)}
              <div
                className={classes.itemBodyBox}
                style={{ display: opens[0] ? 'block' : 'none' }}
              >
                <ul>
                  {item.contents.map(
                    (
                      content: { subject: string; body: string },
                      subIndex: number,
                    ) => (
                      <li key={`exchange-refund-content-${subIndex}`}>
                        <div className={classes.itemWrap}>
                          <div className={classes.subjectBox}>
                            {content.subject.trim()}
                          </div>
                          <div className={classes.conBox}>
                            {content.body
                              .trim()
                              .replace(/\\r\\n|\\n|\\r/gm, '<br/>')}
                          </div>
                        </div>
                      </li>
                    ),
                  )}
                </ul>
              </div>
            </div>
          ),
        )}
      </div>
    </div>
  );
}

export default ShopDetailRefund;
